import { useContext } from 'react'

import SettingsStoreContext from 'contexts/SettingsStoreContext'

const useSettingsStore = () => useContext(SettingsStoreContext)

export default useSettingsStore
